<nav class="prf-header-navbar">
  <ul class="prf-header-list">
    @for (item of this.navItems; track item.id) {
      <li class="prf-header-list-item">
        <a [href]="item.href" (click)="onClickNavItem(item.ymGoal)">{{ item.linkText }}</a>
      </li>
    }
  </ul>
</nav>
